import { CloseIcon } from "@chakra-ui/icons";
import {
  Box,
  Divider,
  Drawer,
  DrawerBody,
  DrawerContent,
  DrawerOverlay,
  Flex,
  IconButton,
  Stack,
  useDisclosure,
} from "@chakra-ui/react";
import { FaBlackTie, FaFile } from "react-icons/fa";
import { FiHelpCircle, FiMenu, FiSettings } from "react-icons/fi";
import { useLocation, useNavigate } from "react-router-dom";
import {
  VACATAIRE_DOCUMENT_PAGE,
  VACATAIRE_PROFIL_PAGE,
} from "../../../utils/navigation/endpoints";
import { NavButton } from "../interaction";
import { LogoClub } from "../logo";
import { MenuAvatar } from "./MenuAvatar";

export const SideNavVacataires = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { isOpen, onOpen, onClose } = useDisclosure();

  const handleNavigateSidenav = (page: string) => {
    navigate(page);
  };
  const isProfilePageActive =
    location.pathname.startsWith("/vacataires/profil");
  const isDocumentPageActive = location.pathname.startsWith(
    "/vacataires/documents"
  );
  const navContent = (
    <Stack justify="space-between">
      <Stack spacing={{ base: "5", sm: "6" }} shouldWrapChildren>
        <LogoClub />
        <Stack spacing="4">
          <NavButton
            label="Mon profil"
            onClick={() => handleNavigateSidenav(VACATAIRE_PROFIL_PAGE)}
            aria-current={isProfilePageActive ? "page" : undefined}
            icon={FaBlackTie}
          />
          <NavButton
            label="Mes documents"
            onClick={() => handleNavigateSidenav(VACATAIRE_DOCUMENT_PAGE)}
            aria-current={isDocumentPageActive ? "page" : undefined}
            icon={FaFile}
          />
        </Stack>
      </Stack>
      <Stack spacing={{ base: "5", sm: "6" }}>
        <Stack spacing="1">
          <NavButton label="Aide" icon={FiHelpCircle} />
          <NavButton label="Options" icon={FiSettings} />
        </Stack>

        <Divider borderColor="bg-accent-subtle" />
        <MenuAvatar />
      </Stack>
    </Stack>
  );

  return (
    <Flex as="section" minH="100vh" bg="primary">
      <IconButton
        visibility={{ base: "visible", md: "hidden" }}
        variant="outline"
        colorScheme="teal"
        aria-label="Send email"
        position="fixed"
        icon={<FiMenu />}
        top="2"
        left="2"
        onClick={onOpen}
      />
      <Drawer isOpen={isOpen} onClose={onClose} placement="left">
        <DrawerOverlay>
          <DrawerContent bg="primary" color="on-accent">
            <DrawerBody p="4">
              {navContent}
              <Box textAlign="right">
                <IconButton
                  variant="outline"
                  aria-label="Fermer le menu"
                  icon={<CloseIcon />}
                  size="sm"
                  onClick={onClose}
                  position="absolute"
                  top={2}
                  right={2}
                />
              </Box>
            </DrawerBody>
          </DrawerContent>
        </DrawerOverlay>
      </Drawer>
      <Flex
        flex="1"
        bg="bg-accent"
        color="on-accent"
        maxW={{ base: "full", md: "xs" }}
        py={{ base: "6", md: "8" }}
        px={{ base: "4", md: "6" }}
        display={{ base: "none", md: "flex" }}
      >
        {navContent}
      </Flex>
    </Flex>
  );
};
